import uploadOrderFile from '../../../Services/uploadOrderFile';

export default (acceptedFiles: FileList) => async (dispatch) => {

  // Incorrect naming (should be valuation, not order)

  dispatch(uploadOrderFile(acceptedFiles))
  
}